<template>
  <div class>
    <div class="tabs-nav flex" :class="layout">
      <div
        @click="changeTabHot(i)"
        class="tab-name"
        :class="[{ active: activeTab === i }, type]"
        v-for="(v, i) in hotList"
        :key="i"
      >
        {{ v.hotTitle }}
        <div style="margin-top: 5px">{{ v.hotAssistantTitle }}</div>
      </div>
      <div class="tips" v-if="hotList.length <= 0">请添加分类名称</div>
    </div>
    <div>
      <el-carousel trigger="click" :height="imgHeight + 'px'">
        <el-carousel-item
          v-for="(v, i) in imgList"
          :key="i"
          @click="toUrl(v.url)"
        >
          <div class="img-ad-wrapper">
            <img
              class="img"
              :src="v.src"
              ref="image"
              alt="图片广告"
              @load="imageLoad"
            />
            <span class="text_ad" v-show="v.text">{{ v.text }}</span>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="tab-body">
      <div class="goods-list" v-if="goodsList.length>0">
        <div v-for="(item, index) in goodsList" :key="index" class="goods-item2">
          <div class="image-wrapper">
            <img :src="item.spuMainPic" v-if="item.spuMainPic" />
            <div class="watermark" v-if="watermark && !hotList[activeTab].watermark">
              <img :src="watermark" />
            </div>
            <div class="watermark" v-if="hotList[activeTab].watermark">
              <img :src="hotList[activeTab].watermark" />
            </div>
          </div>
          <div class="title2_div">
          <span class="title2 clamp">{{ item.goodsName || item.wxshopSpuName }}</span>
            <div v-if="item.gameType">
              <div
                class="tag"
                :class="item.gameType"
                v-if="item.gameType === 'group'"
              >
                拼团
              </div>
              <div
                class="tag"
                :class="item.gameType"
                v-if="item.gameType === 'single_single_exclusive'"
              >
                专享
              </div>
              <div
                class="tag"
                :class="item.gameType"
                v-if="item.gameType === 'bargain'"
              >
                砍价
              </div>
              <div
                class="tag"
                :class="item.gameType"
                v-if="item.gameType === 'seckill'"
              >
                秒杀
              </div>
              <div
                class="tag"
                :class="item.gameType"
                v-if="item.gameType === 'integral_exchange'"
              >
                积分兑换
              </div>
            </div>
            <div class="flex flex-between item-center price-wrapper">
                  <div v-if="item.gameType === 'group'">
                    <div class="primary price-box">
                      {{ item.openteamNumber }}人团
                      <span class="bold"
                        ><span class="price"
                          >{{ String(item.price).split(".")[0] }}.</span
                        >
                        {{
                          String(item.price).split(".")[1]
                            ? String(item.price).split(".")[1]
                            : "00"
                        }}
                      </span>
                    </div>
                    <div class="single-price">
                      单价买<span class="">￥{{ item.wxshopPrice }}</span>
                    </div>
                  </div>
                  <div v-if="item.gameType === 'bargain'">
                    <div class="primary price-box">
                      可砍至
                      <span class="bold"
                        ><span class="price"
                          >{{ String(item.price).split(".")[0] }}.</span
                        >
                        {{
                          String(item.price).split(".")[1]
                            ? String(item.price).split(".")[1]
                            : "00"
                        }}
                      </span>
                    </div>
                    <div class="single-price">
                      <span class="single-price-del"
                        >{{ item.wxshopPrice }}</span
                      >
                    </div>
                  </div>
                  <div v-if="item.gameType === 'seckill'">
                    <div class="primary price-box">
                      <span class="bold"
                        ><span class="price"
                          >{{ String(item.price).split(".")[0] }}.</span
                        >
                        {{
                          String(item.price).split(".")[1]
                            ? String(item.price).split(".")[1]
                            : "00"
                        }}
                      </span>
                    </div>
                    <div class="single-price">
                      <span class="single-price-del"
                        >{{ item.wxshopPrice }}</span
                      >
                    </div>
                  </div>
                  <div v-if="item.gameType === 'integral_exchange'">
                    <div class="primary price-box">
                      <span class="bold price-integral">
                        <span>{{ item.integralValue }}积分+</span>
                        <span>{{ String(item.price).split(".")[0] }}.</span>
                        {{
                          String(item.price).split(".")[1]
                            ? String(item.price).split(".")[1]
                            : "00"
                        }}
                      </span>
                    </div>
                    <div class="single-price">
                      <span class="single-price-del"
                        >{{ item.wxshopPrice }}</span
                      >
                    </div>
                  </div>
                  <div v-if="item.gameType === 'single_single_exclusive'">
                    <div class="primary price-box">
                      <span class="bold"
                        ><span class="price"
                          >{{ String(item.price).split(".")[0] }}.</span
                        >
                        {{
                          String(item.price).split(".")[1]
                            ? String(item.price).split(".")[1]
                            : "00"
                        }}
                      </span>
                    </div>
                    <div class="single-price">
                      <span class="single-price-del"
                        >￥{{ item.wxshopPrice }}</span
                      >
                    </div>
                  </div>
                  <div v-if="!item.gameType && item.showPrice">
                    <div class="primary price-box">
                      ￥{{ item.showPrice }}
                    </div>
                  </div>
                  <div>
                    <button
                      class="btn primary round hot-btn"
                      v-if="item.gameType === 'group'"
                    >
                      去拼团
                    </button>
                    <button
                      class="btn primary round hot-btn"
                      v-if="item.gameType === 'bargain'"
                    >
                      去砍价
                    </button>
                    <button
                      class="btn primary round hot-btn"
                      v-if="item.gameType === 'single_single_exclusive'"
                    >
                      去抢购
                    </button>
                    <button
                      class="btn primary round hot-btn"
                      v-if="item.gameType === 'seckill'"
                    >
                      马上抢
                    </button>
                    <button
                      class="btn primary round hot-btn"
                      v-if="item.gameType === 'integral_exchange'"
                    >
                      去兑换
                    </button>
                    <button
                      class="btn primary round hot-btn"
                      v-if="!item.gameType"
                    >
                      去购买
                    </button>
                  </div>
                </div>
            <!-- <div class="price-box flex" v-if="item.showPrice">
              <span class="price flex-1">{{ item.showPrice }}</span>
            </div> -->
          </div>
          <!-- <div
            class="sold-out-wrapper"
            v-if="!item.stockNum || item.stockNum <= 0"
          >
            <div class="content">当前门店售罄</div>
          </div> -->
        </div>
        <div class="tips" v-if="goodsList.length <= 0">请添加分组商品</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
export default {
  props: {
    hotList: {
      type: Array,
      default: () => []
    },
    imgList:{
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "span"
    },
    layout: {
      type: String,
      default: "flex-start"
    },
    hotImg: {
      type: String,
    }
  },  
  data() {
    return {
      tabList: [
        {
          title: "正在疯抢",
          status: "running",
        },
        {
          title: "即将开始",
          status: "notStart",
        },
        {
          title: "已结束",
          status: "end",
        },
      ],
      activeList: 0,
      goodsList: [],
      groupGoods:{},
      imgHeight: 0,
      activeTab: 0,
      watermark: "",
      gameIds:[],
    };
  },
  watch: {
    hotList(val){
      if(val){
        this.changeTabHot(this.activeTab);
      }
    },    
  },
  onshow(){
    // this.queryHotList();
  },
  methods: {
    queryHotList(i){
      console.log("hotList", this.hotList);
      this.gameIds = [];
      if(this.hotList[i].groupGoods.length > 0){
        this.hotList[i].groupGoods.map((item) => {
          if(item.gameId){
            this.gameIds.push(item.gameId);
          }
        });
      }
      console.log("this.gameIds",this.gameIds);
      this.queryGoodsList(this.gameIds);
    },
    imageLoad() {
      this.$nextTick(() => {
        this.imgHeight = this.$refs.image[0].height;
      });
    },    
    changeTabHot(i) {
      // if (this.activeTab === i) {
      //   return;
      // }
      console.log("changeTab123123123123")
      this.goodsList = [];
      this.activeTab = i;
      if(this.hotList[i].groupGoods.length > 0){
        this.goodsList = this.hotList[i].groupGoods;
        this.watermark = "";
        this.queryHotList(i);        
      }else if(this.hotList[i].groupGoods.groupId){
        this.groupGoods = this.hotList[i].groupGoods;
        this.queryGroupGoods(this.groupGoods.groupId);
      }      
      console.log("this.goodsList",this.goodsList);
      // const groupId = this.hotList[i].groupGoods.gameId || "";
      // this.queryGroupGoods(groupId);
    },
    async queryGroupGoods(groupId) {
      const { storeCode } = getLoginUser();
      this.goodsList = [];
      if (!groupId) {
        return;
      }
      this.queryWatermark(groupId, storeCode);
      const { result } = await this.$store.dispatch("queryGroupGoods", {
        pageSize: 99999,
        pageNo: 1,
        storeCode,
        groupId
      });
      const { records } = result;
      this.goodsList = records;
    },
    async queryWatermark(groupId, storeCode) {
      const { result } = await this.$store.dispatch(
        "queryGroupGoodsWatermark",
        {
          groupId,
          storeCode
        }
      );
      const { groupLabelPic } = result;
      this.watermark = groupLabelPic;
    },
    async queryGoodsList(gameIds) {
      this.goodsList = [];
      const { result } = await this.$store.dispatch(
        "queryStoreHotSaleGameGoodsList",
        {
          gameIds: gameIds,
          queryTimeState: this.tabList[this.activeList].status,
        }
      );
      console.log("result1", result);
      let goodsList = result;
      goodsList.forEach((v) => {
        let goodsSellNum = v.surplusStockSum || 0;
        let total = v.totalStockSum || 0;        
        if (
          v.gameType == "bargains_team" ||
          v.gameType == "lottery_team" ||
          v.gameType == "leader_free_team"
        ) {
          v.gameType = "group";
        }
        v.rate = parseInt(((total - goodsSellNum) / total) * 100);
        v.useNum = total - goodsSellNum;
        v.countDown = "";
      });
      this.goodsList = goodsList;
      console.log("this.goodsList666666",this.goodsList);
    },  
    toUrl() {}
  }
};
</script>

<style lang="scss" type="scoped">
.tabs-nav {
  background: #fff;
  padding: 15px;
  overflow-x: auto;
  white-space: nowrap;
  .tab-name {
    position: relative;
    font-size: 14px;
    padding: 5px 15px;
    cursor: pointer;
    &.text.active {
      color: #e50065;
      font-weight: bold;
    }
    &.button.active {
      background: #e50065;
      border-radius: 30px;
      color: #fff;
    }
    &.line.active:after {
      position: absolute;
      content: "";
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 50%;
      height: 3px;
      background: #e50065;
      border-radius: 30px;
    }
  }
}

.goods-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 16px;
  background: transparent;

  .goods-item2 {
    border-radius: 3px;
    width: 300px;
    background: #fff;
    padding: 20px 30px;
    margin-bottom: 10px;
    position: relative;

    // &:nth-child(2n + 1) {
    //   margin-right: 4%;
    // }
  }

  .image-wrapper {
    position: relative;
    width: 110px;
    height: 110px;
    border-radius: 3px;
    overflow: hidden;
    float: left;
    .watermark {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }
  .title2_div{
    width: 150px;
    float: right;
  }
  .title2 {
    font-size: 14px;
    // margin: 10px;
    // box-sizing: border-box;
    min-height: 34px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .price-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    // padding: 0 10px;
    color: #e50163;
  }

  .price {
    font-size: 12px;
    color: #e50163;
    line-height: 1;

    &:before {
      content: "￥";
      font-size: 13px;
    }
  }
}

.goods-item {
  position: relative;
  .sold-out-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);

    .content {
      position: absolute;
      top: 82px;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.5);
      width: 93px;
      color: #fff;
      text-align: center;
      border-radius: 30px;
      padding: 10px 5px;
    }
  }
}

.tips {
  color: #999;
  font-size: 12px;
}

.text_ad {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background-color: rgba(51, 51, 51, 0.8);
    color: #fff;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
  }
.tag {
  display: inline-block;
  box-sizing: border-box;
  height: 14px;
  line-height: 14px;
  border-radius: 7px;
  font-size: 9px;
  padding: 0 5px;
  color: #fff;
  &.group {
    background: #69aaff;
  }
  &.single_single_exclusive {
    background: #47cea5;
  }
  &.bargain {
    background: #ffad69;
  }
  &.seckill {
    background: #a669ff;
  }
  &.integral_exchange {
    background: #ff6969;
  }
}  
.price-wrapper {
  margin-top: -4px;
  .price-box {
    padding: 10px 0;
    font-size: 12px;
    .price {
      font-size: 14px;
      margin-left: -1px;
    }
    .price-integral {
      font-size: 14px;
    }
  }
}
.single-price {
  font-size: 12px;
  color: #999;
  // margin-top: 17rpx;
  .single-price-del {
    text-decoration: line-through;
  }
}
.hot-btn{
  width: 72px;
  height: 36px;
  margin-top: 20px;
  font-size: 15px;
  border: none;
  background: #E60E6D !important;
  color: #ffffff !important;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
</style>
